import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { StyledButton } from "@insite/mobius/Clickable";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden from "@insite/mobius/Hidden";
import { IconWrapper } from "@insite/mobius/Icon";
import { InputStyle } from "@insite/mobius/TextField";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkList: InjectableCss;
    callWrapper: InjectableCss;
    raqWrapper: InjectableCss;
    contactUsWrapper: InjectableCss;
    signInWrapper: InjectableCss;
    languageWrapper?: InjectableCss;
    cartWrapper: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 5.5rem;
            width: 100%;
            padding: 0px 40px 0 40px;
            margin: 0 auto;
            max-width: 1440px;
            .imgDiv {
                a {
                    span {
                        flex: none;
                    }
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        height: auto;
                        flex-direction: column;
                        position: relative;
                        padding: 10px 24px 0 24px;
                    `,
                    css`
                        height: auto;
                        flex-direction: column;
                        position: relative;
                        padding: 10px 24px 0 24px;
                    `,
                    css`
                        height: auto;
                        flex-direction: column;
                        position: relative;
                        padding-top: 10px;
                    `,
                    null,
                    null,
                ]);
            }}
        `,
    },
    logoWrapper: {
        css: css`
            /* width: 228px; */
            div[class^="Wrapper"] div[class^="sc"] {
                max-width: inherit;
                max-width: 90%;
                > ${StyledButton} {
                    width: 100%;
                    > ${TypographyStyle} {
                        width: 100%;
                        position: relative;
                        top: 4px;
                    }
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-grow: 1;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 100%;
                            > div[class^="Wrapper"] {
                                height: 100%;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            img {
                height: 50px;
                width: 330px;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            height: auto;
                            width: 200px;
                            margin: 0;
                            margin-top: 8px;
                        `,
                        css`
                            height: auto;
                            width: 200px;
                            margin: 0;
                            margin-top: 8px;
                        `,
                        css`
                            height: auto;
                            width: 200px;
                            margin: 0;
                            margin-top: 8px;
                        `,
                        css`
                            height: auto;
                            width: 180px;
                            margin: 0;
                        `,
                        null,
                    ]);
                }};
            }
        `,
    },
    searchMenuWrapper: {
        css: css`
            flex: 1;
            ${FormFieldStyle} {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                z-index: 1;

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            margin-top: 5px;
                        `,
                        css`
                            margin-top: 5px;
                        `,
                        null,
                        null,
                        null,
                    ])}
                > ${FormInputWrapper} {
                    > ${InputStyle} {
                        padding: 12px 95px 12px 24px;
                        &:focus {
                            padding: 12px 95px 12px 24px;
                        }
                    }
                    ${({ theme }) => {
                        return breakpointMediaQueries(theme, [
                            css`
                                width: 100%;
                            `,
                            css`
                                width: 100%;
                            `,
                            css`
                                width: 100%;
                            `,
                            css`
                                width: 34vw;
                                margin-right: 1rem;
                            `,
                            css`
                                width: 35vw;
                            `,
                        ]);
                    }}
                }
            }

            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        padding: 8px 0;
                        width: 100%;
                    `,
                    css`
                        padding: 8px 0;
                        width: 100%;
                    `,
                    css`
                        flex-grow: 8;
                        width: 100%;
                        margin-bottom: 1rem;
                        margin-top: 0.5rem;
                        align-self: center;
                    `,
                    css`
                        padding-left: 1rem;
                        width: 100%;
                    `,
                    css`
                        width: 65%;
                        /* width: 40%; */
                    `,
                ]);
            }}
        `,
    },
    linkList: {
        css: css`
            height: 100%;
            > div[class^="Wrapper"] {
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            order: -1;
                            position: absolute;
                            left: 0;
                            > div[class^="Wrapper"] {
                                height: auto;
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    callWrapper: {
        css: css`
            /* padding: 3px; */
            /* margin: 0 0.5rem; */
            padding: 0 10px;
            width: 90px;
            .mobileView {
                display: none;
            }
            .imgHeader {
                margin-right: 0rem;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            order: -1;
                            position: absolute;
                            right: 50px;
                            padding: 15px 11px 0px 0px;
                            .mobileView {
                                display: block;
                            }
                            .desktopView {
                                display: none;
                            }
                            .contactText {
                                display: none;
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    raqWrapper: {
        css: css`
            /* padding: 3px; */
            /* margin: 0 0.5rem; */
            padding: 0 10px;
            width: 100px;
            .mobileView {
                display: none;
            }
            .raqText {
                display: block;
                text-align: center;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                width: 92px;
            }
            .imgDiv a {
                justify-content: flex-end;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            order: -1;
                            position: absolute;
                            right: 100px;
                            padding: 15px 11px 0px 0px;
                            .mobileView {
                                display: block;
                            }
                            .desktopView {
                                display: none;
                            }
                            .raqText {
                                display: none;
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    contactUsWrapper: {
        css: css`
            //  margin: 0 0.5rem;
        `,
    },
    languageWrapper: {
        css: css`
            /* margin: 0 0.5rem; */
            height: 100%;
            padding: 0 10px;
            /* padding-top: 1.1rem; */
            > div[class^="Wrapper"] {
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                > div[class^="sc"] {
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    > nav {
                        flex: 0 1 auto;
                        min-width: 0px;
                        height: 100%;
                        position: relative;
                        display: flex;
                        align-items: center;
                        > ul {
                            top: 100%;
                        }
                    }
                }
            }
            ${StyledButton} {
                flex-direction: column;
                height: initial;
            }
            ${IconWrapper} {
                color: ${getColor("primary")} !important;
                height: 24px;
                width: 24px;
                margin-top: -3px;
            }
            ${TypographyStyle} {
                font-size: 14px;
                color: ${getColor("text.main")};
                text-transform: capitalize;
            }
        `,
    },
    signInWrapper: {
        css: css`
            /* margin: 0 0.5rem; */
            height: 100%;
            padding: 0 10px 0px 15px;
            /* padding-top: 1.1rem; */
            > div[class^="Wrapper"] {
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                > div[class^="sc"] {
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    > nav {
                        flex: 0 1 auto;
                        min-width: 0px;
                        height: 100%;
                        position: relative;
                        display: flex;
                        align-items: center;
                        > ul {
                            top: 100%;
                        }
                    }
                }
            }
            ${StyledButton} {
                flex-direction: column;
                height: initial;
            }
            ${IconWrapper} {
                color: ${getColor("primary")} !important;
                height: 24px;
                width: 24px;
                margin-top: -3px;
            }
            ${TypographyStyle} {
                font-size: 14px;
                color: ${getColor("text.main")};
                text-transform: capitalize;
            }
        `,
    },
    cartWrapper: {
        css: css`
            padding: 0 0 0 10px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 17px 7px 0px 0px !important;
                        `,
                        null,
                        css`
                            order: -1;
                            position: absolute;
                            right: 3px;
                            top: 3px;
                            padding: 17px 11px 0px 0px;
                            ${StyledButton} {
                                padding: 5px;
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => (
    <StyledWrapper {...logoLinksSearchStyles.container}>
        <StyledWrapper {...logoLinksSearchStyles.logoWrapper}>
            <Zone contentId={id} zoneName="Logo" />
        </StyledWrapper>
        <StyledWrapper {...logoLinksSearchStyles.searchMenuWrapper}>
            <Zone contentId={id} zoneName="Search" />
        </StyledWrapper>
        <Hidden below="md" {...logoLinksSearchStyles.raqWrapper}>
            <Zone contentId={id} zoneName="RequestAQuote" />
        </Hidden>
        <Hidden below="md" {...logoLinksSearchStyles.callWrapper}>
            <Zone contentId={id} zoneName="Call" />
        </Hidden>
        <Hidden below="lg" {...logoLinksSearchStyles.signInWrapper}>
            <Zone contentId={id} zoneName="Sign In" />
        </Hidden>
        <Hidden below="lg" {...logoLinksSearchStyles.languageWrapper}>
            <Zone contentId={id} zoneName="Language" />
        </Hidden>
        <StyledWrapper {...logoLinksSearchStyles.cartWrapper}>
            <Zone contentId={id} zoneName="Cart" />
        </StyledWrapper>
    </StyledWrapper>
);

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
